import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { FormGroup } from '@angular/forms';
import { IUserSessionData, UserState } from '../../store/models/user.model';
import { Subject } from 'rxjs';
import { ContentService } from '../../store/services/content.service';
import { SessionService } from '../../store/services/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { EReducers, IReducers } from '../../store/reducers';
import { DomSanitizer } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';
import { IContent } from '../../store/models/content.model';
import { openSnackbar } from '../../store/actions/page.action';

@Component({
  selector: 'app-preview-master-content',
  templateUrl: './preview-master-content.component.html',
  styleUrls: ['./preview-master-content.component.scss'],
})
export class PreviewMasterContentComponent implements OnInit, OnDestroy {
  templates: IContent[];
  dataReady = false;
  formGroup: FormGroup;
  selectedIndex = 0;
  signature = '';
  userData: IUserSessionData;
  contentGroupId: number;
  @ViewChild('stepper') private MyStepper: MatStepper;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private contentService: ContentService,
    private sessionService: SessionService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<IReducers>,
    private readonly domSanitizer: DomSanitizer,
  ) {
    this.contentGroupId = this.activatedRoute.snapshot.params.id;
    this.store.select(EReducers.USER).subscribe((userState: UserState) => {
      if (userState.sessionData) {
        this.userData = userState.sessionData;

        this.signature = this.userData.signature;
      }
    });
  }

  ngOnInit() {
    if (!this.contentGroupId) {
      this.router.navigate(['/contents']);
      return;
    }
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.contentService
          .getContentsByGroupId(this.contentGroupId)
          .subscribe(response => {
            this.templates = response;
            this.formGroup = new FormGroup({});

            for (const item of this.templates) {
              this.formGroup.addControl(
                `form_${item.content_id}`,
                new FormGroup({}),
              );
            }
            this.dataReady = true;
            if (this.activatedRoute.snapshot.queryParams.index) { // send index after apply!!!!
              this.selectedIndex =
                +this.activatedRoute.snapshot.queryParams.index - 1;
            }
          });
      });
  }

  getGroup(id: number) {
    return this.formGroup.get(`form_${id}`);
  }

  editTemplate(id: number, index: number) {
    this.router.navigate([
      '/contents',
      'edit-master-content',
      id,
      this.contentGroupId,
    ]);
  }

  stepperNext() {
    this.MyStepper.next();
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  getContent(content: string) {
    if (!content) {
      return '';
    }

    return this.domSanitizer.bypassSecurityTrustHtml(
      content.replace(/(\r\n)/gm, '<br>'),
    );
  }

  onFinish() {
    this.store.dispatch(
      openSnackbar({
        snackbarData: {
          data: {
            message: 'Content has been updated successfully',
            type: 'success',
          },
        },
      }),
    );
    this.router.navigate(['/contents/content_group']);
  }
}
